import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Markdown from '../../../components/Markdown';
import CountUp from 'react-countup';

const useStyles = makeStyles(theme => ({
  statCard: {
    '& h1': {
      color: theme.palette.common.tealish,
      padding: 0,
      margin: 0,
    },
    '& p': {
      color: theme.palette.text.hint,
      borderTopColor: theme.palette.text.hint,
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      paddingTop: '1rem',
    },
  },
}));

const countDecimals = val => {
  const parts = val.toString().split('.');
  return parts.length > 1 ? parts[1].length : 0;
};

const ProviderStat = ({count, prefix, suffix, detail}) => {
  const classes = useStyles();
  return (
    <CountUp
      start={0}
      end={count}
      delay={0}
      duration={3}
      separator=","
      decimals={countDecimals(count)}
      suffix={suffix}
      prefix={prefix}
    >
      {({ countUpRef}) => (
        <div className={classes.statCard}>
          <h1 ref={countUpRef}>{prefix}{count}{suffix}</h1>
          <Markdown content={detail}/>
        </div>
      )}
    </CountUp>
  );
};

ProviderStat.propTypes = {
  count: PropTypes.number.isRequired,
  prefix: PropTypes.string.isRequired,
  suffix: PropTypes.string.isRequired,
  detail: PropTypes.string.isRequired,
};

export default ProviderStat;
